import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const BusinessInterruptionTab = Loadable(
  lazy(() => import("./BusinessInterruptionTab"))
);

const BusinessInterruptionForm = Loadable(
  lazy(() => import("./BusinessInterruptionForm"))
);

export const BusinessInterruptionTabRoutes = [
  {
    path: `/business-policy/:customerId/business-interruption-tab/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInterruptionTab />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/business-interruption-tab/:customerPolicyId/create`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInterruptionForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/business-policy/:customerId/business-interruption-tab/:customerPolicyId/manage/:incrementalNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessInterruptionForm />
      </AuthorizedRoute>
    ),
  },
];
